import React from "react";
import { useTranslation } from "react-i18next";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import {
  FillTheFieldErrorMessage,
  FormInput,
  FormTextArea,
  FormYearDatePicker,
} from "@/shared/Components";
import type { FieldProps } from "@/pages/ContactsPage/types";

export const Career: React.FC<FieldProps> = ({ index }) => {
  const { t } = useTranslation();

  return (
    <FieldLayout>
      <FillTheFieldErrorMessage name={`careers.${index}`} />
      <FormInput
        name={`careers.${index}.company`}
        placeholder={t("contactsPage.activities.company")}
      />
      <FormInput
        name={`careers.${index}.jobTitle`}
        placeholder={t("contactsPage.activities.jobTitle")}
      />
      <FormInput
        name={`careers.${index}.industry.name`}
        placeholder={t("contactsPage.activities.industry")}
      />
      <FormYearDatePicker
        placeholder={t("common.dateFrom")}
        name={`careers.${index}.careerStart`}
      />
      <FormYearDatePicker placeholder={t("common.dateTo")} name={`careers.${index}.careerEnd`} />
      <FormTextArea name={`careers.${index}.about`} placeholder={t("common.about")} />
    </FieldLayout>
  );
};
